export default __webpack_public_path__ + "static/media/instagram.5239adeb.svg";